if (!customElements.get('marquee-component')) {
  class MarqueeComponent extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      const container = this.querySelector('[data-marquee-inner]');
      if (!container) return;

      const runMarqueeSetup = () => {
        const items = Array.from(container.children);
        if (items.length === 0) return;

        const viewportWidth = this.offsetWidth || window.innerWidth;
        
        let singleLoopWidth = 0;
        items.forEach(item => {
          singleLoopWidth += item.getBoundingClientRect().width || item.offsetWidth || 200;
        });

        const targetWidth = Math.max(viewportWidth * 2, singleLoopWidth * 2);
        let currentWidth = singleLoopWidth;

        while (currentWidth < targetWidth) {
          items.forEach(item => {
            const clone = item.cloneNode(true);
            clone.setAttribute('aria-hidden', 'true');
            container.appendChild(clone);
          });
          currentWidth += singleLoopWidth;
        }

        container.classList.add('marquee--active');
      };

      if (document.readyState === 'complete' || document.readyState === 'interactive') {
        runMarqueeSetup();
      } else {
        window.addEventListener('DOMContentLoaded', runMarqueeSetup);
      }

      if (this.dataset.pauseOnHover === 'true') {
        container.addEventListener('mouseenter', () => {
          container.style.animationPlayState = 'paused';
        });
        container.addEventListener('mouseleave', () => {
          container.style.animationPlayState = 'running';
        });
      }
    }
  }

  customElements.define('marquee-component', MarqueeComponent);
}
